import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navbarClass = isHome && !isScrolled
    ? 'bg-transparent text-white'
    : 'bg-white text-gray-800 shadow-sm';

  const linkClass = isHome && !isScrolled
    ? 'text-white hover:text-orange-200 transition-colors'
    : 'text-gray-700 hover:text-orange-600 transition-colors';

  const logoClass = isHome && !isScrolled
    ? 'text-white'
    : 'text-orange-600';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navbarClass}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="https://static.readdy.ai/image/e9e586bd4793f176311c78b231428f92/5baa20667f1859ec46821643381a37bc.png"
              alt="Task Zone!"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className={linkClass}>
              Inicio
            </Link>
            <Link to="/explorar" className={linkClass}>
              Servicios
            </Link>
            <Link to="/sobre-task-zone" className={linkClass}>
              Sobre Task Zone!
            </Link>
            <Link to="/registro-proveedor" className={linkClass}>
              Ser Proveedor
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link to="/iniciar-sesion">
              <Button 
                variant={isHome && !isScrolled ? 'outline' : 'primary'}
                size="sm"
              >
                Iniciar Sesión
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
